export const localStorageConstants = {
  testingHarness: 'testingHarness',
};
